import { cn } from "@tabipla/ui";

export type IllustrationName =
  | "travel-plans"
  | "chat-with-ai"
  | "team-up"
  | "savings"
  | "invite"
  | "celebration"
  | "adventure"
  | "exploring"
  | "schedule"
  | "to-do-list"
  | "share-link"
  | "relaxing"
  | "loading"
  | "warning";

interface IllustrationProps {
  name: IllustrationName;
  alt: string;
  className?: string;
}

export function Illustration({ name, alt, className }: IllustrationProps) {
  return (
    <img
      src={`/illustrations/${name}.svg`}
      alt={alt}
      className={cn("h-auto max-w-full", className)}
      loading="lazy"
    />
  );
}
